// extracted by mini-css-extract-plugin
export default {"form":"Form_form__WzUSO","button__container":"Form_button__container__Ttny8","button__wrap":"Form_button__wrap__AyUYg"};